import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

import {
  Page,
  Link,
  Logo,
} from 'components';
import { useBreakpoint } from 'hooks';
import { BUILD_VERSION } from 'settings';
import { getSettings } from 'utils/settings';

import useStyles from './styles';

function LayoutAuth({ children }) {
  const classes = useStyles();
  const isMobile = ['sm', 'xs'].includes(useBreakpoint());
  // Number(): el contrato exige number (guía §3.2/§3.3), pero se tolera un
  // string numérico en el JSON del tenant (React no agrega 'px' a strings y
  // el estilo se perdería). Inválido/ausente ⇒ null ⇒ fallback 38.
  const configWidth = Number(getSettings('logo.width')) || null;

  return (
    <div className={classes.root}>
      <Box className={classes.mainContent}>
        <Page
          className={classes.pageContainer}
          style={{
            backgroundColor:
              'transparent',
          }}
        >
          <Box className={classes.contentCenter}>
            <Box mb={4}>
              <Logo style={{
                maxHeight: isMobile ? 24 : (configWidth ?? 38),
              }} variant='imagotipo' />
            </Box>

            {children}
          </Box>
        </Page>
      </Box>

      <footer className={classes.footer}>
        <Box className={classes.footerContent}>
          <Typography variant="caption" className={classes.versionText}>
            {`Versión ${BUILD_VERSION}`}
          </Typography>

          <Box className={classes.linksContainer}>
            <Link
              to="https://pinpeo.com/terminos-y-condiciones.html"
              variant="external"
              className={classes.footerLink}
            >
              Términos y condiciones
            </Link>

            <Link
              to="https://pinpeo.com/aviso-de-privacidad.html"
              variant="external"
              className={classes.footerLink}
            >
              Aviso de privacidad
            </Link>
          </Box>
        </Box>
      </footer>
    </div>
  );
};

LayoutAuth.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default LayoutAuth;
